import React from 'react';
import PropTypes from 'prop-types';
import Error from './Error';
import { encode } from 'utilities';
import { css } from 'react-emotion';

const codeBlock = css`
  word-break: break-all;
  width: 300px;
  color: #fff;
  margin: 0 auto;
`;

const InternalError = ({ code }) => (
  <Error
    title={'Ups! Zdarzyło się coś nieoczekiwanego i aplikacja przestała działać.'}
    subtitle={
      <div>
        Jeśli problem się powtarza - powiadom administację portalu.
        {code && (
          <React.Fragment>
            <br/>
            Możesz też wysłać poniższy kod błędu, który ułatwi rozwiązanie problemu.
          </React.Fragment>
        )}
      </div>
    }
  >
    <div className={codeBlock}>{encode(code)}</div>
  </Error>
);

InternalError.propTypes = {
  code: PropTypes.string.isRequired,
};
export default InternalError;


// WEBPACK FOOTER //
// ./src/components/ui/InternalError.jsx